// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import axios from 'axios';
import '@vant/touch-emulator';
Vue.prototype.axios = axios;
Vue.config.productionTip = false

//设置登录过期时间（7天）
let EXPIRESTIME =86400000*7
let date=new Date(). getTime();

router.beforeEach(function(to, from, next) {
  if(to.meta.title){
    document.title=to.meta.title
  }
  if (to.meta.needLogin) {
    if(store.state.userinfo && store.state.userinfo.nickname){
      next();
    } else {
       next({
         path: '/'
       });
    }
  }else{
    next();
  }
});

new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js